<template>
    <div>
        <div class="row">
            <div class="col">
                <fuel-discounts-mutations-new-filter @getDiscountMutations="getDiscountMutations"
                                                     @showHideFuels="showHideFuels"
                                                     @emptyFilterProductsStations="resetIsConfirmed"
                                                     :products="products"
                                                     :stations="stations"
                                                     :isConfirmed="isConfirmed"
                />
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col">
                <fuel-discounts-mutations-new-table
                    :discountMutationsPerStation="discountMutationsPerStation"
                    :showFuels="showFuels"
                    :isLoaded="isLoaded"
                    :isLoading="isLoading"
                    :messages="messages"
                    :postSuccessful="postSuccessful"
                    :discountRows="discountRows"
                    @updateDiscount="updateDiscount"
                    @updateDiscountRows="updateDiscountRows"
                />
            </div>
        </div>
    </div>
</template>

<script>

import _empty from 'lodash/isEmpty'
import _forEach from 'lodash/forEach'
import _forEachRight from 'lodash/forEachRight'
import axios from "axios";

export default {
    props: {
        products: Array,
        stations: Array,
    },
    data() {
        return {
            isLoading: false,
            isLoaded: false,
            isConfirmed: false,
            messages: [],
            postSuccessful: null,
            discountMutationsPerStation: [],
            showFuels : true,
            discountRows: []
        };
    },
    methods: {
        showHideFuels(active){
            this.showFuels = active;
        },
        resetIsConfirmed() {
            this.isConfirmed = false;
        },

        addNewStationsFromRequest(newData, mutationsPerStation) {
            _forEach(newData, value => mutationsPerStation.push(value));
        },

        mergeStationProductDataFromNewRequest(stationMutations, newStationProducts) {
            _forEachRight(stationMutations, (stationProduct, productIndex) => {
                let key = newStationProducts.findIndex(product => {
                    return product.product_id === stationProduct.product_id;
                });

                if (key >= 0) {
                    newStationProducts.splice(key, 1);
                } else {
                    stationMutations.splice(productIndex, 1)
                }
            });

            _forEach(newStationProducts, newProduct => { stationMutations.push(newProduct) });
        },

        mergeStationDataFromNewRequest(mutationsPerStation, newData) {
            let $this = this;

            _forEachRight(mutationsPerStation, (mutations, index) => {
                let stationId = mutations[0].station_id;
                let isStationInNewData = Object.keys(newData).findIndex(id => parseInt(id) === stationId) >= 0;

                if (! isStationInNewData) {
                    mutationsPerStation.splice(index, 1)
                } else {
                    $this.mergeStationProductDataFromNewRequest(mutations, newData[stationId]);

                    delete newData[stationId]
                }
            });

            this.addNewStationsFromRequest(newData, mutationsPerStation);
        },

        getDiscountMutations(filter) {
            let selectedProducts = filter[0];
            let selectedStations = filter[1];

            this.isLoaded = false;
            this.isLoading = true;

            axios.get(route('admin.api.discounts.new', {products: selectedProducts, stations: selectedStations}))
                .then((response) => {
                    if (typeof response.data === 'object' && !_empty(response.data)) {
                        this.mergeStationDataFromNewRequest(this.discountMutationsPerStation, response.data);
                    } else {
                        this.discountMutationsPerStation = []
                    }
                })
                .catch(() => {
                    this.isLoading = false

                    if (!this.isLoaded) {
                        this.isLoaded = true
                        this.$emit('loaded')
                    }
                })
                .then(() => this.$nextTick(() => {
                    this.isLoading = false

                    if (!this.isLoaded) {
                        this.isLoaded = true
                        this.$emit('loaded')
                    }
                }))
        },

        updateDiscount(formData) {
            this.isLoading = true

            axios.post(route('admin.api.discounts.create'), formData)
                .then((response) => {
                    this.messages = response.data.messages || [];
                    this.postSuccessful = response.data.success || false;

                    if (this.postSuccessful) {
                        this.discountMutationsPerStation = [];
                        this.isConfirmed = true;
                    }
                })
                .catch((response) => {
                    this.messages = []
                    this.postSuccessful = false
                    this.isLoading = false
                })
        },

        updateDiscountRows(discountRowsList) {
            this.discountRows = discountRowsList;
        }
    }
}
</script>
